<!DOCTYPE html>
<head>
<meta name="viewport" content="width=device-width, initial-scale=1">
</head>
<ng-container *ngIf="user">
  <app-toolbar [title]="title" [user]="user" [back]="true" [destination]="destination"></app-toolbar>
</ng-container>
<div class="column">
  <h2> Questionari globali - Numero di questionari compilati divisi per sesso</h2>
  <div style="display: inline-block" style="padding-left: 0vw;padding-top: 1vw">
    <ng-container *ngIf="doughnutChartDataDoctor">
      <div class="chart-container" [ngStyle]="{'cursor': isHovered ? 'pointer' : ''}">
        <canvas baseChart
                [data]="doughnutChartDataDoctor"
                [options]="doughnutChartOptions"
                [labels]="doughnutChartLabels"
                [chartType]="doughnutChartType"
                [colors]="colorsOptions">
        </canvas>
      </div>
    </ng-container>
  </div>
</div>
<div class = "column" style="padding-right: 1vw; padding-top: 5vw; display: inline-block; position: center;">
    <table mat-table [dataSource]="elementsD" class="mat-elevation-z8">
      <!-- pathology Column -->
      <ng-container matColumnDef="gender">
        <th mat-header-cell *matHeaderCellDef> Questionari compilati </th>
        <td mat-cell *matCellDef="let element"> {{element.gender}} </td>
        <td mat-footer-cell *matFooterCellDef> Totale questionari </td>
      </ng-container>
      <!-- number of patients Column -->
      <ng-container matColumnDef="number">
        <th mat-header-cell *matHeaderCellDef> Numero di questionari </th>
        <td mat-cell *matCellDef="let element"> {{element.number}} </td>
        <td mat-footer-cell *matFooterCellDef> {{totalPatientsD}} </td>
      </ng-container>
      <!-- pathology Description Column -->
      <ng-container matColumnDef="item-description">
        <th mat-header-cell *matHeaderCellDef> Name of Pathology </th>
      </ng-container>
      <!-- number of patients Description Column -->
      <ng-container matColumnDef="cost-description">
        <th mat-header-cell *matHeaderCellDef> Number of patients </th>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="headElements"></tr>
      <tr mat-row *matRowDef="let row; columns: headElements;"></tr>
      <tr mat-footer-row *matFooterRowDef="headElements"></tr>
    </table>
  </div>
  <div style="float:left;">
    <app-bar-chart-questionnaires-total>
    </app-bar-chart-questionnaires-total>
  <app-bar-chart-average-questionnaires-per-patient>
  </app-bar-chart-average-questionnaires-per-patient>
<app-bar-chart-questionnaires-avg>
</app-bar-chart-questionnaires-avg>
</div>